import { render, staticRenderFns } from "./user_wtfw_detial.vue?vue&type=template&id=f6a6281a&scoped=true"
import script from "./user_wtfw_detial.vue?vue&type=script&lang=js"
export * from "./user_wtfw_detial.vue?vue&type=script&lang=js"
import style0 from "./user_wtfw_detial.vue?vue&type=style&index=0&id=f6a6281a&prod&scoped=true&lang=less"
import style1 from "./user_wtfw_detial.vue?vue&type=style&index=1&id=f6a6281a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a6281a",
  null
  
)

export default component.exports